import { DealFlag, TeamDeal } from 'app/models/dto/team-deal';
import { DealNote } from 'ng2-app/models/dto/dealNote.model';
import { Note } from 'ng2-app/models/dto/note.model';

// eslint-disable-next-line @typescript-eslint/no-namespace
export namespace TeamDealsActions {

  export class GetTeamDeals {
    static readonly type = '[TeamDeals] GetDeals';
    constructor(public id: number) {}
  }

  export class GetLenderUserDeals {
    static readonly type = '[TeamDeals] GetLenderUserDeals';
    constructor(public id: number) {}
  }

  export class TeamDealFlagAdded {
    static readonly type = '[TeamDeals] TeamDealFlagAdded';
    constructor( public dealFlag: DealFlag ) {}
  }

  export class TeamDealFlagRemoved {
    static readonly type = '[TeamDeals] TeamDealFlagRemoved';
    constructor( public dealId: number ) {}
  }

  export class SetSelectedUserIds {
    static readonly type = '[TeamDeals] SetSelectedUserIds';
    constructor( public userIds: number[] ) {}
  }

  export class UpdateDealNoteContent {
    static readonly type = '[TeamDeals] UpdateDealNote';
    constructor( public dealNote: DealNote ) {}
  }

  export class UpdateBorrowerNoteContent {
    static readonly type = '[TeamDeals] UpdateBorrowerNoteContent';
    constructor( public note: Note ) {}
  }

  export class SetDealsTypeFilter {
    static readonly type = '[TeamDeals] SetDealsTypeFilter';
    constructor(
      public dealsTypeFilter: string
    ) {}
  }

  export class ExcludeDealFromTeamDeals {
    static readonly type = '[TeamDeals] ExcludeDealFromTeamDeals';
    constructor(
      public deal: TeamDeal,
    ) {}
  }

  export class UnExcludeDealFromTeamDeals {
    static readonly type = '[TeamDeals] UnExcludeDealFromTeamDeals';
    constructor(
      public dealId: number
    ) {}
  }

  export class ExcludeLenderFromTeamDeals {
    static readonly type = '[TeamDeals] ExcludeLenderFromTeamDeals';
    constructor(
      public lenderId: number,
    ) {}
  }

  export class UnExcludeLenderFromTeamDeals {
    static readonly type = '[TeamDeals] UnExcludeLenderFromTeamDeals';
    constructor(
      public lenderId: number,
    ) {}
  }

  export class SetTeamDealsExcludedLenders {
    static readonly type = '[TeamDeals] SetTeamDealsExcludedLenders';
    constructor(
      public lenderIds: number[],
    ) {}
  }

  export class ClearExcludedTeamDealsLenders {
    static readonly type = '[TeamDeals] ClearExcludedTeamDealsLenders';
    constructor() {}
  }

  export class GetTeamDealsLocalStorage {
    static readonly type = '[TeamDeals] GetTeamDealsLocalStorage';
    constructor() {}
  }

  export class ClearExcludedTeamDeals {
    static readonly type = '[TeamDeals] ClearExcludedTeamDeals';
    constructor() {}
  }

}
